import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import Breadcrumb from '../../component/Breadcrumb';
import PageTabing from '../../component/PageTabing';
import { options } from '../../constants';
import { fetchAutoCompleteHomePage } from '../../api/mappingApi';
import swal from 'sweetalert';
import STHomePageModal from './STHomePageModal';
import STHomePageRows from './STHomePageRows';


const STHomePage = () => {

    const inputRef  = useRef(null);
    const [open, setOpen]                         = React.useState(false);
    const [sheetMappingData, setSheetMappingData] = React.useState([]);
    const [sheetFilter, setSheetFilter]     = React.useState('');
    const [searchValue, setSearchValue]     = React.useState('');
    const [autoCompleteLoading, setAutoCompleteLoading] = React.useState(false);
    const [fieldsModal, setFieldsModal] = React.useState({
        Sheet     :    '',
        PId       :    '',
    });
    const [fields, setFields] = React.useState([]);

    useEffect(() => {
        let existingHomepage= JSON.parse(localStorage.getItem('HomePage'));
        if(existingHomepage != null && existingHomepage.length > 0){
           // let exisitingModBusWithSheets = existingHomepage.map(val => ({...val,Sheet:val?.Addr.substring(0,2).toLowerCase()}));
            setFields(existingHomepage);
        }
    },[])

   

    useEffect(() => {
        const fetchAutoCompleteData = () => {
            if(searchValue === ''){
                setSheetMappingData([]);
                return;
            }
            let active;
            if(sheetFilter){
                active = true;
                ( async () => {
                        setAutoCompleteLoading(true);
                        const data = await fetchAutoCompleteHomePage(sheetFilter,searchValue);
                        if(active){
                            setSheetMappingData(data);
                            setAutoCompleteLoading(false);
                        }
                    }
                )();
            }
            return () => {
                active = false;
            }
        };
        
        fetchAutoCompleteData();
    },[sheetFilter,searchValue])

    const handleChangeAutoComplete = (values) => {
        if(values) {
            Object?.keys(values)?.map(val => val === 'PId' ? setFieldsModal((prevState) =>  ({...prevState, [val]: values[val] })) : '');
        }
    }

    const handleSearchValueAutoComplete = (value) => {
        setSearchValue(value);
    }

    const changeHandler = (name,value) => {
        if(name === 'Sheet'){
            setSheetFilter(value)
        }
        setFieldsModal((prevState) =>  ({...prevState, [name]: value }));
    };

    const handleDeleteInput = (index) => {
        const newArray = [...fields];
        newArray.splice(index, 1);
        setFields(newArray);
        // let existingHomepage = JSON.parse(localStorage.getItem('homepage'));
        // console.log('existingHomepage',existingHomepage)
        // let remainingPIds = existingHomepage.filter(val => val.PId !== Pid)
        // console.log('remainingPIds',remainingPIds)
    };


    const handleAddModalFormData = () => {
        let error = (fieldsModal.Sheet === '' || fieldsModal.PId === '') ? true : false;
        if(error){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        let duplicatePID;
        duplicatePID =  fields.some(val => val.PId === fieldsModal.PId ? true : false);
        if(duplicatePID){
            swal("Oops!", "PID is already used. Please select different PID number.", "error");
            return false;
        }
        setFields(fields => [...fields, fieldsModal]);
        setOpen(false);
    }


    const handleFormData = async () => {
        let error = false;
        fields.map((val) => (val.PId === '') ? error = true : error);
        if(error){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        let homepage = [];
        fields.map(item => {
            delete item.Sheet
            let itemNew = {...item,PId: parseInt(item.PId)}
            return homepage.push(itemNew);
        });
        localStorage.setItem('HomePage',JSON.stringify(homepage));
        let existingHomepage= JSON.parse(localStorage.getItem('HomePage'));
        if(existingHomepage != null && existingHomepage.length > 0){
            setFields(existingHomepage);
        }
        swal({
            title: "Success",
            text: 'STHome Page PID added successfully.',
            icon: "success",
        })
    }

    const handleClickOpen = () => {
        setOpen(true);
    };
  
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if(!open){
            setFieldsModal({
                Sheet   :    '',
                PId     :    '',
            });
            setSheetFilter('');
            setSheetMappingData([]);
        }        
    },[open])

    return (
        <>
            <Breadcrumb  title="ST Homepage">
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                Homepage
                </Typography>
            </Breadcrumb>
            <PageTabing value="st-homepage" />
            <Box  component="section">
                <Grid className="contentBox">
                    <Grid sx={{pr:'15px !important'}} className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                onClick={handleClickOpen}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Add New 
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                disabled={fields.length === 0 ? true : false}
                                onClick={handleFormData}
                                variant="contained"
                                size="small"
                                color="secondary"
                            >Submit
                            </Button>
                        </Grid>
                    </Grid>
                    {fields?.length > 0 && fields?.every(val => val.RegAddr !== '')  &&
                        <STHomePageRows 
                            fields={fields}
                            handleDeleteInput={handleDeleteInput}
                        />
                    }
                </Grid>
            </Box>
            <STHomePageModal
                open={open}
                inputRef={inputRef}
                fields={fieldsModal} 
                onClose={handleClose}
                options={options}
                changeHandler={changeHandler} 
                handleDeleteInput={handleDeleteInput} 
                autoCompleteOptions={sheetMappingData}
                autoCompleteLoading={autoCompleteLoading}
                handleAddModalFormData={handleAddModalFormData}
                handleChangeAutoComplete={handleChangeAutoComplete}
                handleSearchValueAutoComplete={handleSearchValueAutoComplete}
            /> 
        </>
    );
};

export default STHomePage;
